// package.json
var version = "11.3.0";

export {
  version
};
